import { sliderAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import getThemes, { ThemesKeys } from './themeShared';

const style = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = (theme: ThemesKeys) =>
  style.definePartsStyle({
    // define the part you're going to style
    thumb: {
      bg: getThemes(theme).colors.palette.primary[50],
      _focusVisible: {
        boxShadow: getThemes(theme).shadows.lg,
      },
    },
    filledTrack: {
      bg: getThemes(theme).colors.palette.primary[60], // change the background of the filled track to blue.600
    },
  });

export const sliderTheme = (theme: ThemesKeys) =>
  style.defineMultiStyleConfig({
    baseStyle: baseStyle(theme),
  });

export default (theme: ThemesKeys) => sliderTheme(theme);
